<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                        </span>
                    </h2>
                </v-row>
        
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >
                    <v-row>
                        <v-col cols="2" sm="2" class="pb-n4">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.daterecorded')"
                                type="date"
                                ref="recorddate"
                                :rules="[rules.required]"
                                v-model="formData.recorddate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.incidentdate')"
                                type="date"
                                ref="incidentdate"
                                :rules="[rules.required]"
                                v-model="formData.incidentdate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                   
                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.caseid')"
                                type="text"
                                ref="caseid"
                                :rules="[rules.required]"
                                v-model="formData.caseid"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.incidentshortdesc')"
                                type="text"
                                ref="shortdesc"
                                :rules="[rules.required]"
                                v-model="formData.shortdesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-textarea
                                outlined
                                :label="this.$t('ircasemaintenance.incidentlongdesc')"
                                type="text"
                                ref="longdesc"
                                v-model="formData.longdesc"
                                @input="updateValue"
                                dense
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('ircasemaintenance.incidentcat')"
                                type="text"
                                ref="incidentcatid"
                                :rules="[rules.required]"
                                :items="incidentcatList"
                                hide-selected
                                v-model="formData.incidentcatid"
                                @input="updateValue"
                                @change="changeIncidentCatHandler(formData.incidentcatid)"
                                dense
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                dense
                                :label="this.$t('columns.code')"
                                outlined
                                readonly
                                background-color="#ffeab2"
                                v-model="irincidentcatcode"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-dialog v-model="incidentcatDialog" max-width="500px" persistent>
                                <template v-slot:activator="{ on }">
                                    <v-btn dense v-on="on">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <app-genericform 
                                        v-bind:parentData = "{
                                            tabItems: incidentcatItems,
                                            formTitle: `${this.$t('ircasemaintenance.incidentcat')}`,
                                            formId: 'incidentcat'
                                        }"

                                        v-on:input="itemData = $event"
                                        v-on:saveIncidentCat="saveIncidentCatHandler"
                                        v-on:deleteIncidentCat="deleteIncidentCatHandler"
                                    />

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="warning"
                                            text
                                            @click="incidentcatDialog = false"
                                        >
                                            {{$t('button.close')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="4" sm="8" class="pb-n4 mt-n6">
                            <v-autocomplete
                                outlined
                                :label="this.$t('ircasemaintenance.reportedby')"
                                type="text"
                                ref="psnid"
                                :rules="[rules.required]"
                                v-model="formData.reportedbyid"
                                dense
                                :items="staffDetailsList"
                                @input="updateValue"
                                @change="changeStaffIDandCompanyHandler(formData.reportedbyid)"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        
                        <!-- <v-col cols="4" sm="4" class="pb-n4 mt-n6">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.staffid')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.staffcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col> -->
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.staffid')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.staffcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.company')"
                                type="text"
                                ref="compnyid"
                                v-model="formData.compnyname"
                                dense
                                readonly
                                append-icon=""
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                ref="remarks"
                                v-model="formData.remarks"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- <v-row >
                        <v-col cols="8" sm="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('ircasemaintenance.casestatus')"
                                type="text"
                                ref="casestatusid"
                                :rules="[rules.required]"
                                v-model="formData.casestatusid"
                                dense
                                :items="casestatusList"
                                @input="updateValue"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                    </v-row> -->

                    <v-row>
                        <v-col cols="8" sm="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('ircasemaintenance.casestatus')"
                                type="text"
                                ref="casestatusid"
                                :rules="[rules.required]"
                                v-model="formData.casestatusid"
                                dense
                                :items="casestatusList"
                                @change="changeCaseStatusHandler(formData.casestatusid)"
                                @input="updateValue"
                                clearable
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                dense
                                :label="this.$t('columns.code')"
                                outlined
                                readonly
                                background-color="#ffeab2"
                                v-model="casestatuscode"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-dialog v-model="casestatusDialog" max-width="500px" persistent>
                                <template v-slot:activator="{ on }">
                                    <v-btn dense v-on="on">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <app-genericform 
                                        v-bind:parentData = "{
                                            tabItems: casestatusItems,
                                            formTitle: `${this.$t('ircasemaintenance.casestat')}`,
                                            formId: 'casestat'
                                        }"

                                        v-on:input="itemData = $event"
                                        v-on:saveCaseStat="saveCaseStatusHandler"
                                        v-on:deleteCaseStat="deleteCaseStatusHandler"
                                    />

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="warning"
                                            text
                                            @click="casestatusDialog = false"
                                        >
                                            {{$t('button.close')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.statusremarks')"
                                type="text"
                                ref="statusremarks"
                                v-model="formData.statusremarks"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                            <v-file-input
                            ref="attach"
                            :label="formData.attach ? formData.attachname : this.$t('claimrecordlisting.browseforattachment')"
                            outlined
                            v-model="fileHolder"
                            @change="fileToBase64"
                            @input="updateValue" 
                            dense
                            ></v-file-input>
                        </v-col>
                    </v-row>

                    <div v-if="isEdit">
                        <v-row>
                            <v-col cols="4" sm="6" class="ml-1 mt-n5">
                                <p>
                                    <a v-bind:href="this.formData.attach" v-bind:download="this.formData.attachname" style="display: inline-block; padding: 4px 8px; cursor: pointer; color: blue; text-decoration: underline;">
                                        {{formData.attachname}}
                                    </a>
                                    <v-icon
                                        small
                                        class="ml-3 mr-2"
                                        @click="deleteAttachmentHandlerNew"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </p>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row>
                        <v-col cols="4" sm="8" class="pb-n4 mt-n5">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.documentdesc')"
                                type="text"
                                ref="attachdesc"
                                v-model="formData.attachdesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>              
                    
                </v-container>
 

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.editMode

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

            </v-form>

        </v-container>
    </div>
</template>

<script>
//import axios from 'axios';
import GenericForm from '../../generic/GridForm';
//import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-genericform': GenericForm,
        //'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail')
                }
            },
            formData: {
                id: this.parentObject.data.id,
                recorddate: this.parentObject.data.recorddate,
                incidentdate: this.parentObject.data.incidentdate,
                caseid: this.parentObject.data.caseid,
                shortdesc: this.parentObject.data.shortdesc,
                longdesc: this.parentObject.data.longdesc,
                incidentcatid: this.parentObject.data.incidentcatid,
                reportedbyid: this.parentObject.data.reportedbyid,
                staffcode: this.parentObject.data.staffcode,
                compnyname: this.parentObject.data.compnyname,
                remarks: this.parentObject.data.remarks,
                casestatusid: this.parentObject.data.casestatusid,
                statusremarks: this.parentObject.data.statusremarks,
                attach: this.parentObject.data.attach,
                attachdesc: this.parentObject.data.attachdesc,
                attachname: this.parentObject.data.attachname,
                docid: this.parentObject.data.docid,
                docdid: this.parentObject.data.docdid,
                documents: this.parentObject.data.documents,
                lockstaff: this.parentObject.data.lockstaff,
                search: this.parentObject.data.search,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
          
            itemData: {
                itemcode: null,
                itemdesc: null,
                itemstamp: 0
            },

            irincidentcatcode: '',
            incidentcats: [],
            incidentcatItems: [],
            incidentcatList: [],
            incidentcatDialog: false,

            casestatuscode: '',
            casestatus: [],
            casestatusItems: [],
            casestatusList: [],
            casestatusDialog: false,

            staffdetails: [],
            staffDetailsList: [],

            fileHolder: null,
            isFileProcessing: false,

            filename: [],
            attachnew: [],
            uploadDocuments : null,

            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.editMode,
            search: this.parentObject.searchnew,
        }
    },

    methods: {

        downloadFile() {
            console.log('downloadFile', this.formData.attach, this.formData.attachname)
            const link = document.createElement("a");
            link.href = this.formData.attach;
            link.download = this.formData.attachname;
            link.click();
        },

        fileToBase64() {
            if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
            this.formData.attachname = this.fileHolder.name
            
            var reader = new FileReader();

            reader.onloadend = async () => {
                const base64 = reader.result;

                if (base64.includes('image')) {
                    try {
                        const resizedBase64 = await this.resizeImage(base64, 300); // Adjust maxSizeKB as needed
                        this.formData.attach = resizedBase64;
                    } catch (err) {
                        console.error('Image resize error:', err.message);
                        this.formData.attach = base64; // fallback to original base64 if resize fails
                    }
                } else {
                    this.formData.attach = base64; // for non-images like PDFs
                }
            };

            reader.readAsDataURL(file);
          } else {
              this.formData.attach = null
          }
        },

        resizeImage(dataURI, maxSizeKB, maxAttempts = 10) {
            return new Promise((resolve, reject) => {
                if (dataURI.includes('image')) {
                this.checkSize(dataURI, maxSizeKB).then(sizeOK => {
                    if (sizeOK) {
                    return resolve(dataURI);
                    }

                    const resizeAndCheck = (dataURI, attempt = 1) => {
                    if (attempt > maxAttempts) {
                        return reject(new Error('Image size exceeds the maximum allowed size.'));
                    }

                    const image = new Image();
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        let width = image.width;
                        let height = image.height;
                        const maxDim = 800;

                        if (width > height) {
                        if (width > maxDim) {
                            height = height * (maxDim / width);
                            width = maxDim;
                        }
                        } else {
                        if (height > maxDim) {
                            width = width * (maxDim / height);
                            height = maxDim;
                        }
                        }

                        canvas.width = width;
                        canvas.height = height;

                        ctx.drawImage(image, 0, 0, width, height);
                        const resizedDataURI = canvas.toDataURL('image/jpeg', 0.6);

                        this.checkSize(resizedDataURI, maxSizeKB).then(ok => {
                        if (ok) {
                            resolve(resizedDataURI);
                        } else {
                            resizeAndCheck(resizedDataURI, attempt + 1);
                        }
                        }).catch(reject);
                    };

                    image.onerror = () => reject(new Error('Failed to load image for resizing.'));
                    image.src = dataURI;
                    };

                    resizeAndCheck(dataURI);
                }).catch(reject);
                } else if (dataURI.includes('application')) {
                    this.checkSize(dataURI, maxSizeKB).then(sizeOK => {
                        if (sizeOK) resolve(dataURI);
                        else reject(new Error('File size exceeds the maximum allowed size.'));
                    }).catch(reject);
                } else {
                reject(new Error('Unsupported file type.'));
                }
            });
        },

        deleteAttachmentHandlerNew() {
            this.formData.attach = ''
            this.formData.attachname = ''
        },


        loadCaseStatus() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/ircasestatus/all'
            })
            .then(res => {
                vm.casestatus = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.casestatusList.push(
                        {
                            text: res.data.rec[i].casestatusdesc,
                            value: res.data.rec[i].id
                        }
                    )

                    vm.casestatusItems.push(
                        {
                            id: res.data.rec[i].id,
                            code: res.data.rec[i].casestatuscode,
                            desc: res.data.rec[i].casestatusdesc,
                            stamp: res.data.rec[i].stamp
                        }
                    )
                }

                if (this.formData.casestatusid) {
                    this.changeCaseStatusHandler(this.formData.casestatusid);
                }

            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        changeCaseStatusHandler(id) {
            var item = this.casestatusItems.find(item => item.id === id);
            this.casestatuscode = item.code
        },

        saveCaseStatusHandler() {
            const vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/ircasestatus/' + this.itemData.itemid, 
                    payload: {
                        casestatuscode: this.itemData.itemcode,
                        casestatusdesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.formData.userid,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.casestatus = [];
                        vm.casestatusItems = [];
                        vm.casestatusList = [];

                        this.loadCaseStatus();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/ircasestatus/create',  
                    payload: {
                        casestatuscode: this.itemData.itemcode,
                        casestatusdesc: this.itemData.itemdesc,
                        userid: this.formData.userid,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.casestatus = [];
                        vm.casestatusItems = [];
                        vm.casestatusList = [];

                        this.loadCaseStatus();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteCaseStatusHandler($event) {
            const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/ircasestatus/' + $event.id + '/' + this.formData.userid})
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.casestatus = [];
                        vm.casestatusList = [];
                        vm.casestatusItems = [];

                        this.loadCaseStatus();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }
        },

         //load staffdetails list view
        loadStaffDetailsListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: "/staff/all/" + this.formData.userid

            })
                .then(res => {
                    //req success --> push res into array
                    vm.staffdetails = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.staffDetailsList.push({
                            text: res.data.rec[i].psndetails,
                            value: res.data.rec[i].id
                        });
                    }
                })
                .catch(err => {
                    //req failure --> emit error
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //change staff id and company after selecting psnnid
        changeStaffIDandCompanyHandler(id) {
            let item = this.staffdetails.find(item => item.id === id);

            //set psnid to psnid and staffid to staffid
            this.formData.psnid = item.psnid;
            this.formData.reportedbyid = item.id;
            this.formData.staffcode = item.staffcode;
            this.formData.compnyname = item.compnyname;
            // this.formData.compnyid = item.compnyid;
            // this.formData.compnyname = item.compnyname;

            this.updateValue();
        },

        
        // loading the content of currency from the database, providing the name of the currency on the dropdown box
        loadIncidentCatListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/incidentcat/all'})
                .then(res => {
                    vm.incidentcats = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.incidentcatList.push(
                            {
                                text: res.data.rec[i].irincidentcatdesc,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.incidentcatItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].irincidentcatcode,
                                desc: res.data.rec[i].irincidentcatdesc,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }

                    if (vm.formData.incidentcatid) {
                        vm.changeIncidentCatHandler(vm.formData.incidentcatid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeIncidentCatHandler(id) {
            let item = this.incidentcats.find(item => item.id === id);

            this.irincidentcatcode = item.irincidentcatcode;
        },

        saveIncidentCatHandler() {
            const vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/incidentcat/' + this.itemData.itemid, 
                    payload: {
                        irincidentcatcode: this.itemData.itemcode,
                        irincidentcatdesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.formData.userid,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.incidentcats = [];
                        vm.incidentcatItems = [];
                        vm.incidentcatList = [];

                        this.loadIncidentCatListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/incidentcat/create',  
                    payload: {
                        irincidentcatcode: this.itemData.itemcode,
                        irincidentcatdesc: this.itemData.itemdesc,
                        userid: this.formData.userid,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.incidentcats = [];
                        vm.incidentcatItems = [];
                        vm.incidentcatList = [];

                        this.loadIncidentCatListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteIncidentCatHandler($event) {
            const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/incidentcat/' + $event.id + '/' + this.formData.userid})
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.incidentcats = [];
                        vm.incidentcatList = [];
                        vm.incidentcatItems = [];

                        this.loadIncidentCatListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }
        },

        updateValue() {
            this.$emit('input', {
                id: this.formData.id,
                recorddate: this.formData.recorddate,
                incidentdate: this.formData.incidentdate,
                caseid: this.formData.caseid,
                shortdesc: this.formData.shortdesc,
                longdesc: this.formData.longdesc,
                incidentcatid: this.formData.incidentcatid,
                reportedbyid: this.formData.reportedbyid,
                staffcode: this.formData.staffcode,
                compnyname: this.formData.compnyname,
                remarks: this.formData.remarks,
                casestatusid: this.formData.casestatusid,
                statusremarks: this.formData.statusremarks,
                attach: this.formData.attach,
                attachdesc: this.formData.attachdesc,
                attachname: this.formData.attachname,
                docid: this.formData.docid,
                docdid: this.formData.docdid,
                lockstaff:this.formData.lockstaff,
                documents: this.formData.documents,
                //ircasemaintenancedetail: this.formData.ircasemaintenancedetail,
                search: this.formData.search,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });

           // console.log('docdid', this.formData.attach.id)
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'ircasemaintenancelist', params: { search: this.search}});
        },
    },

    mounted() {
        console.log(this.parentObject);
        this.loadIncidentCatListHandler();
        this.loadStaffDetailsListHandler();
        this.loadCaseStatus();
       
        if (this.parentObject.editMode){
            this.duplicateStaffData = this.formData;
            
            if (this.parentObject.data.lockstaff == "N") {
                this.formData.lockstaff = false;
            } else {
                this.formData.lockstaff = true;
            }
        }
    }
}
</script>